import { appBuildKey, useGlobalState } from '@libs/client'

export const useAppBuild = () => {
  const [appBuild, setAppBuild] = useGlobalState<number>(appBuildKey)
  return [appBuild, setAppBuild] as const
}
